import api from "../api";

const base = () => api.getBaseUrl() + "practice/";

export const getScenarios = (language) =>
  api.getApi().get(base() + "scenarios", { params: language ? { language } : undefined });
export const getPracticeSessions = () => api.getApi().get(base() + "sessions");
export const getPracticeSession = (id) => api.getApi().get(base() + "sessions/" + id);
export const deletePracticeSessions = () => api.getApi().delete(base() + "sessions");
export const deletePracticeSession = (sessionId) =>
  api.getApi().delete(base() + "sessions/" + sessionId);
export const createVoiceSession = (sessionId, language, voice) =>
  api.getApi().post(base() + `sessions/${sessionId}/voice-session`, { language, voice });
export const endVoiceCall = (voiceCallId) =>
  api.getApi().post(base() + `voice-calls/${voiceCallId}/end`);
export const saveVoiceTranscript = (sessionId, role, content) =>
  api.getApi().post(base() + `sessions/${sessionId}/voice-transcript`, { role, content });
export const checkVoiceSafety = (sessionId, content) =>
  api.getApi().post(base() + `sessions/${sessionId}/voice-check`, { content });
// Accepts a scenarioId (number) OR a freeform payload: { mode: "open" } | { situation: "..." }
export const startPracticeSession = (payload, language) => {
  const body =
    typeof payload === "object" && payload !== null
      ? { ...payload, language }
      : { scenarioId: payload, language };
  return api.getApi().post(base() + "sessions", body);
};
export const sendPracticeMessage = (sessionId, content, language) =>
  api.getApi().post(base() + `sessions/${sessionId}/messages`, { content, language });
export const getSessionFeedback = (sessionId, language) =>
  api.getApi().post(base() + `sessions/${sessionId}/feedback`, { language });
export const abandonPracticeSession = (sessionId) =>
  api.getApi().post(base() + `sessions/${sessionId}/abandon`);
export const getPracticeSpeechSource = (text, language) => {
  const params = new URLSearchParams({
    text,
    language: language || "en",
    v: String(Date.now()),
  });
  return base() + `speak?${params.toString()}`;
};

export const getJournalReflection = (language) =>
  api.getApi().get(base() + "journal/reflection", { params: { language } });
export const getJournalEntries = () => api.getApi().get(base() + "journal");
export const createJournalEntry = (data) => api.getApi().post(base() + "journal", data);
export const deleteJournalEntry = (id) => api.getApi().delete(base() + "journal/" + id);

export const getGoals = () => api.getApi().get(base() + "goals");
export const createGoal = (text) => api.getApi().post(base() + "goals", { text });
export const updateGoal = (id, achieved) =>
  api.getApi().patch(base() + "goals/" + id, { achieved });
export const deleteGoal = (id) => api.getApi().delete(base() + "goals/" + id);

export const analyzeConversation = (text, language) =>
  api.getApi().post(base() + "flag-analysis", { text, language });
// Analyze a screenshot of a conversation (File from an <input type=file>).
export const analyzeConversationImage = (file, language) => {
  const form = new FormData();
  form.append("image", file);
  if (language) form.append("language", language);
  return api.getApi().post(base() + "flag-analysis", form);
};
export const getFlagAnalyses = () => api.getApi().get(base() + "flag-analysis");
export const deleteFlagAnalysis = (id) =>
  api.getApi().delete(base() + "flag-analysis/" + id);

// Coach memory (personalization)
export const getCoachProfile = () => api.getApi().get(base() + "coach-profile");
export const updateCoachProfile = (data) => api.getApi().put(base() + "coach-profile", data);
export const generateCoachPlan = (language) => api.getApi().post(base() + "coach-plan", { language });
